import { confirmDialog } from 'primereact/confirmdialog';
import { t } from 'i18next';
import { ReactNode } from 'react';

interface CustomDialogProps {
  header?: ReactNode;
  message?: ReactNode;
  defaultFocus?: string;
  rejectClassName?: string;
  acceptLabel?: string;
  rejectLabel?: string;
  accept: () => void;
  reject?: () => void;
  /** Każde zamknięcie okna — przyciskiem, krzyżykiem albo Escape. */
  onHide?: () => void;
  /**
   * Klasa okna TYLKO dla tego wywołania (PrimeReact bierze opcje z każdego `confirmDialog` osobno) —
   * zastępuje klasę hosta `<ConfirmDialog>`, więc musi zawierać `dialog-box`.
   */
  className?: string;
  /** Bez stopki z przyciskami — okno zamyka tylko krzyżyk / Escape (np. zmiany zapisywane od razu). */
  hideFooter?: boolean;
}

export const showErrorDialog = ({ accept, reject }: CustomDialogProps) => {
  showCustomDialog({
    header: t('upgradePlanError'),
    message: t('upgradePlanErrorDesc'),
    acceptLabel: t('OK'),
    rejectClassName: 'hide',
    accept,
    reject,
  });
};

export const showCustomDialog = ({
  header = t('areYouSure'),
  message = t('areYouSureProceed'),
  rejectClassName = '',
  defaultFocus = 'accept',
  acceptLabel = t('yes'),
  rejectLabel = t('no'),
  accept,
  reject,
  onHide,
  className,
  hideFooter,
}: CustomDialogProps) => {
  confirmDialog({
    ...(className && { className }),
    ...(hideFooter && { footer: () => null }),
    header,
    message,
    defaultFocus,
    rejectClassName,
    acceptLabel,
    rejectLabel,
    accept,
    reject,
    onHide,
  });
};
